export function newRelicJSError(error) {
    try {
        newrelic.noticeError(error);
    } catch (err) {
        console.error("Error calling newrelic: " + err);
        console.error("Original error: ", error);
    }
}
